import { useSelector } from 'react-redux';

const useConceptDatasets = ({
  selectedConcept,
  compareConcepts,
  dataType,
  colorPalette = BACKGROUND_COLORS,
  isGlobalPercentage,
}) => {
  const conceptsData = useSelector((state) => state.resonance.concepts);

  if (!conceptsData?.length || !selectedConcept) {
    return [];
  }

  return [selectedConcept, ...compareConcepts]?.map((conceptOption, index) => {
    const concept = conceptsData.find((concept) => concept.id === conceptOption.value);
    const sortedData = [...concept[dataType]].sort((a, b) => a.subName.localeCompare(b.subName));

    return {
      label: conceptOption.label,
      data: sortedData.map((conceptElement) =>
        isGlobalPercentage ? conceptElement.globalTotal : conceptElement.total,
      ),
      backgroundColor: getCycledColor(index, colorPalette),
      ...DATASET_CONFIG,
    };
  });
};

export default useConceptDatasets;

export const BACKGROUND_COLORS = ['#2D9CDB', '#27AE60', '#EB5757', '#BB6BD9', '#56CCF2', '#F2994A', '#6FCF97'];

export const GREEN_COLORS = ['#6FCF97', '#27AE60', '#137547', '#A3CB38', '#1ABC9C'];

export const RED_COLORS = ['#EB5757', '#D62828', '#FF7F50', '#A31621', '#6E0D25'];

const DATASET_CONFIG = {
  borderWidth: 0,
  borderRadius: 8,
};

export const getCycledColor = (index, palette) => {
  return palette[index % palette.length];
};
